let ctx = null;
let enabled = true;

export function setSoundEnabled(v) {
  enabled = v;
}

function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  if (ctx && ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, dur, type = "sine", vol = 0.14, delay = 0) {
  if (!enabled) return;
  const a = ac();
  if (!a) return;
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(a.destination);
  const t = a.currentTime + delay;
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur);
}

export const playTap = () => tone(430, 0.07, "triangle", 0.06);
export const playError = () => tone(150, 0.2, "sawtooth", 0.1);
export const playSuccess = () => {
  tone(523, 0.12, "sine", 0.1, 0);
  tone(659, 0.14, "sine", 0.1, 0.1);
};
export const playVictory = () => {
  [523, 659, 784, 1046].forEach((f, i) => tone(f, 0.2, "sine", 0.13, i * 0.12));
};

// Built-in sound effects for the coding studio
export const SFX = {
  boing: () => { tone(180, 0.28, "sine", 0.16); tone(120, 0.3, "sine", 0.12, 0.08); },
  zap: () => { tone(900, 0.05, "square", 0.1); tone(1500, 0.06, "square", 0.09, 0.05); tone(400, 0.12, "sawtooth", 0.1, 0.1); },
  chime: () => { [784, 988, 1319].forEach((f, i) => tone(f, 0.25, "sine", 0.12, i * 0.09)); },
  drum: () => { tone(90, 0.18, "sine", 0.22); tone(60, 0.22, "triangle", 0.18, 0.04); },
  honk: () => { tone(300, 0.18, "square", 0.14); tone(240, 0.2, "square", 0.12, 0.12); },
  laser: () => { [1200, 900, 600, 300].forEach((f, i) => tone(f, 0.06, "sawtooth", 0.1, i * 0.04)); },
};
export const playSfx = (name) => { const fn = SFX[name]; if (fn) fn(); };

// Harvest chapter (Buma Adventures Lesson 3): a soft olive "pluck" per tree and a warm cheer when Teta appears.
export const playPick = () => { tone(660, 0.05, "triangle", 0.07); tone(880, 0.09, "sine", 0.08, 0.05); };
export const playCheer = () => {
  [392, 523, 659, 784, 1046].forEach((f, i) => tone(f, 0.22, "sine", 0.12, i * 0.09));
  [1319, 1568].forEach((f, i) => tone(f, 0.35, "triangle", 0.07, 0.5 + i * 0.12));
};
